import { selectRecipesTotal, useT, useAppSelector } from "@reciperoll/core";
import { Link } from "react-router-dom";
import { Plus, ChevronRight } from "react-feather";

// Prompt to add a recipe, shown only until the library has a few recipes and
// only on small screens (desktop has the sidebar add button). Mirrors RN.
export default function QuickAdd() {
  const t = useT();
  const numRecipes = useAppSelector(selectRecipesTotal);
  if (numRecipes >= 4) return null;

  return (
    <Link
      to="/recipes/new"
      className="md:hidden flex items-center gap-4 mb-8 border-2 border-dashed border-terracotta/40 bg-terracotta-wash rounded-2xl px-4 py-5 hover:opacity-90 transition-opacity"
    >
      <div className="w-12 h-12 rounded-xl bg-terracotta flex items-center justify-center shrink-0">
        <Plus className="w-5 h-5 text-white" />
      </div>
      <div className="flex-1 min-w-0">
        <p className="text-base font-bold text-ink mb-1">{t("home.addARecipe")}</p>
        <p className="text-sm text-ink-soft">{t("home.pasteOrType")}</p>
      </div>
      <ChevronRight className="w-5 h-5 text-terracotta-ink shrink-0" />
    </Link>
  );
}
